var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 50,
    height: 51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-840 21772)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 840, -21772)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    rx: 15,
    transform: "translate(3 2)",
    fill: "#15b5d8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(856.148 -21757.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.479,8.217a1.947,1.947,0,0,0-2.739.238l-1.849,2.188V4.3a1.957,1.957,0,0,0-.607-1.413L13.817.541A1.941,1.941,0,0,0,12.474.005H1.949A1.951,1.951,0,0,0,0,1.954V20.231A1.951,1.951,0,0,0,1.949,22.18H14.942a1.951,1.951,0,0,0,1.949-1.949v-3.55l4.828-5.719A1.948,1.948,0,0,0,21.479,8.217ZM12.993,1.551c2.6,2.469,2.415,2.289,2.463,2.352H12.993Zm2.6,18.68a.65.65,0,0,1-.65.65H1.949a.65.65,0,0,1-.65-.65V1.954a.65.65,0,0,1,.65-.65h9.745V4.553a.65.65,0,0,0,.65.65h3.248v6.979L12.83,15.449a1.959,1.959,0,0,0-.4.8l-.6,2.527a.65.65,0,0,0,.89.747L15.1,18.49a1.959,1.959,0,0,0,.494-.31Zm-1.545-4.209,1,.835-.221.262a.652.652,0,0,1-.239.178l-1.192.517.3-1.264a.651.651,0,0,1,.133-.265Zm1.833-.158-.995-.835,3.591-4.249.993.833Zm4.845-5.739-.418.5-.992-.833.419-.5a.647.647,0,0,1,.991.834Z",
    transform: "translate(0 -0.005)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.599 3.898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.144,90h-6.5a.65.65,0,1,0,0,1.3h6.5a.65.65,0,0,0,0-1.3Z",
    transform: "translate(-59.998 -90.003)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.599 7.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.042,181H60.648a.65.65,0,1,0,0,1.3H71.042a.65.65,0,0,0,0-1.3Z",
    transform: "translate(-59.998 -181.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.599 11.737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.042,271H60.648a.65.65,0,1,0,0,1.3H71.042a.65.65,0,0,0,0-1.3Z",
    transform: "translate(-59.998 -271)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.599 15.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.144,361h-6.5a.65.65,0,0,0,0,1.3h6.5a.65.65,0,0,0,0-1.3Z",
    transform: "translate(-59.998 -360.998)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportNotes);
export default __webpack_public_path__ + "static/media/SupportNotes.b973c3f13abd62fa296447e0ac5d8630.svg";
export { ForwardRef as ReactComponent };